export default __webpack_public_path__ + "static/media/main-image.40f1181a.svg";